import React from "react";
import { Navigate, useLocation } from "react-router";
import { useAuth } from "./Auth";
import { LoadingScreen } from "./LoadingScreen";

export function Protected(props: React.PropsWithChildren) {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.isHydrated) {
    return <LoadingScreen />;
  }

  if (!auth.isAuthenticated) {
    // Guarding against redirecting back to the logout url
    const redirectLocation = {
      ...location,
      search: new URLSearchParams(
        Array.from(new URLSearchParams(location.search)).filter(([key]) => key !== "logout"),
      ).toString(),
    };
    const loginSearchParams = new URLSearchParams();
    for (const [key, value] of new URLSearchParams(location.search)) {
      if (key === "business_ref" || key === "email" || key.startsWith("utm_")) {
        loginSearchParams.set(key, value);
      }
    }
    const loginSearch = loginSearchParams.toString();

    return (
      <Navigate
        to={{ pathname: "/login", search: loginSearch ? `?${loginSearch}` : "" }}
        replace
        state={{
          redirectAfterLogin: redirectLocation,
        }}
      />
    );
  }

  return <>{props.children}</>;
}
